<template>
  <b-row class="pb-30">
    <b-col cols="3" md="6">
      <div
        class="photo"
        :style="{
          'background-image': 'url(' + photo + ')'
        }"
      ></div>
    </b-col>
    <b-col cols="9" md="6">
      <h4>{{ quote }}</h4>
      <p class="fs12 pt-10">
        {{ name }}, {{ position }} <br />at {{ company }}
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    photo: {
      required: true
    },
    quote: String,
    name: String,
    position: String,
    company: String
  }
}
</script>

<style lang="scss" scoped>
.photo {
  padding-bottom: 125%;
  background: no-repeat center center / cover;
}

h4 {
  font-size: 30px;

  @include media-breakpoint-down(sm) {
    font-size: 20px;
  }
}
</style>
